<template>
  <div id="lnews">
    <div class="newFirst">
      <div class="newFirstLeft">基本信息</div>
    </div>
    <div>
      <Form
        :model="formItem.user"
        ref="formItem"
        :rules="ruleCustom"
        :label-width="80"
      >
        <div class="formTitle"></div>
        <Row>
          <Col span="12">
            <FormItem label="" class="newForm">
              <p>身份证号</p>
              <Input
                v-model="formItem.user.idCard"
                placeholder="请输入身份证号"
                readonly
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="执业地区">
              <Input
                v-model="formItem.user.administrativeRegion"
                placeholder="请输入执业地区"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="" class="newForm">
              <p>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 名</p>
              <Input
                v-model="formItem.user.fullName"
                placeholder="请输入姓名"
                readonly
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="执业范围">
              <Select v-model="formItem.user.jobId" @on-change="nishigesha(formItem.user.jobName)">
                <Option
                  :value="item.value"
                  v-for="(item, index) in list1"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="" class="newForm">
              <p>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 别</p>
              <!-- <Input
                                v-model="formItem.user.sex"
                                placeholder="请输入性别"
                            ></Input> -->
              <Select v-model="formItem.user.sex">
                <Option
                  v-for="item in sexList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="工作单位">
              <Input
                v-model="formItem.user.companyName"
                placeholder="请输入工作单位"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="" class="newForm" prop="mobile">
              <p>手&nbsp;&nbsp;机&nbsp;&nbsp;号</p>
              <Input
                v-model="formItem.user.mobile"
                placeholder="请输入手机号"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="专业类别">
              <Select v-model="formItem.user.majorId">
                <Option
                  :value="item.id"
                  v-for="(item, index) in list"
                  :key="index"
                  >{{ item.majorName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="" class="newForm">
              <p>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 话</p>
              <Input
                v-model="formItem.user.workPhone"
                placeholder="请输入电话"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="最高学历">
              <!-- <Input
                                v-model="formItem.user.educationBackground"
                                placeholder="请输入最高学历"
                            ></Input> -->
              <Select v-model="formItem.user.educationBackground">
                <Option
                  v-for="item in educationList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="" class="newForm" prop="mail">
              <p>电子邮箱</p>
              <Input
                v-model="formItem.user.mail"
                placeholder="请输入电子邮箱"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="所学专业">
              <Input
                v-model="formItem.user.major"
                placeholder="请输入所学专业"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <!-- <div class="formTitle">教材邮寄地址</div>
        <Row>
          <Col span="24">
            <FormItem label="" class="newForm">
              <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 址</p>
              <Input
                v-model="formItem.user.province"
                placeholder="请输入地址"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="" class="newForm">
              <p>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 编</p>
              <Input
                v-model="formItem.user.postalCode"
                placeholder="请输入邮编"
              ></Input>
            </FormItem>
          </Col>
        </Row> -->
        <FormItem>
          <Button
            @click="newsBtn('formItem')"
            class="lBtn"
            type="primary"
            style="background: #3562e8"
            >提交修改</Button
          >
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  getNews,
  postNews,
  getSelectMajor,
  queryJob,
} from "../../../network/LPersonal";
export default {
  name: "news",
  
  data() {
     const mail = (rule, value, callback) => {
                if (!(/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value))) {
                    callback(new Error('请输入正确的邮箱'));
                } else {
                    callback();
                }
            };
    const validatePass = (rule, value, callback) => {
        if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value))) {
            callback(new Error('请输入正确的手机号'));
        } else {
            callback();
        }
    };
    return {
      userId: "",
      list: [],
      list1: [
        {
            value: 1,
            label: '生产'
        },
        {
            value: 2,
            label: '经营'
        },
        {
            value: 3,
            label: '批发'
        },
        {
            value: 4,
            label: '使用'
        },
        {
            value: 5,
            label: '教育'
        },
        {
            value: 6,
            label: '科研'
        },
        {
            value: 7,
            label: '管理'
        },
        {
            value: 8,
            label: '其他'
        }
      ],
      formItem: {
        user: {},
        address: {
          address: "",
          postalCode:"",
        }
      },
      ruleCustom: {
        mail: [
          {
            validator: mail,
            trigger: "blur",
          },
        ],
        mobile: [{
            required: true,
            validator: validatePass,
            trigger: "blur"
        }, ],
      },
      sexList: [
        { value: 1, label: "男" },
        { value: 0, label: "女" },
      ],
      educationList: [
        { value: 1, label: "小学" },
        { value: 2, label: "初中" },
        { value: 3, label: "高中" },
        { value: 4, label: "大专" },
        { value: 5, label: "本科" },
        { value: 6, label: "硕士" },
        { value: 7, label: "博士" },
        { value: 8, label: "博士后" },
      ],
    };
    
  },
  created() {
    this.userId = this.Get("userId");
    this.get();
    this.getSelectMajor();
    this.$emit("editPage", "账户资料", "基本信息");
    // this.queryJob();
  },
  activated(){
    this.userId = this.Get("userId");
    this.get();
    this.getSelectMajor();
    this.$emit("editPage", "账户资料", "基本信息");
  },
  methods: {
    Get(name) {
      return Cookies.get(`admin-${name}`);
    },
    newsBtn(name) {
      console.log(1);
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$Message.success('Success!');
          console.log(this.formItem, "提交表单");
          let params = JSON.parse(JSON.stringify(this.formItem));
          params.user.idCard = null;
          postNews(params).then((res) => {
            console.log(res.data, "信息修改成功");
            if (res.data.code == 200) {
              this.$Message.success("修改成功");
              this.get();
            }
          });
        } else {
          // this.$Message.error('Fail!');
        }
      });
    },
    // 接口方法
    get() {
      console.log(this.userId);
      getNews({
        userId: this.userId,
      }).then((r) => {
        console.log(r, "个人信息");
        this.formItem = r.data.data;
        
        // console.log(this.formItem.user.idCard);
      });
    },
    getSelectMajor() {
      getSelectMajor().then((r) => {
        console.log(r, "专业类别");
        this.list = r.data.data;
      });
    },
    queryJob() {
      queryJob().then((r) => {
        console.log(r, "执业范围");
        // this.list1 = r.data.data;
      });
    },
  },
};
</script>

<style scoped>

@import url("../../../assets/css/liucss/news.css");
</style>